<section class="rea-section rea-section--history" [class.rea-section--history-collapsed]="!showPanel">
	<div class="rea-section__header">
		<div>
			<h4>Importaciones anteriores</h4>
			<p class="rea-section__hint">Solo hace falta abrirlo si soporte te lo pide o quieres revisar intentos anteriores.</p>
		</div>
		<p-button
			[label]="showPanel ? 'Ocultar' : 'Ver importaciones anteriores'"
			severity="secondary"
			size="small"
			(onClick)="togglePanel.emit()"
		></p-button>
	</div>

	@if (showPanel) {
		<div class="rea-history-list">
			@for (record of records; track record.importId) {
				<article class="rea-history-entry">
					<button
						type="button"
						class="rea-history-item"
						[class.rea-history-item--active]="isSelectedAuditRecord(record)"
						[attr.aria-expanded]="isSelectedAuditRecord(record)"
						(click)="selectRecord.emit(record)"
					>
						<span>
							<b>{{ record.createdAt }}</b>
							<small>{{ auditRecordTitle(record) }}</small>
						</span>
						<span class="rea-history-item__status">
							<p-tag [value]="auditStatusLabel(record)" [severity]="auditSeverity(record.statusCode)" [rounded]="true"></p-tag>
							@if (isAuditRecordLoading(record)) {
								<i class="pi pi-spin pi-spinner" aria-hidden="true"></i>
							} @else if (isSelectedAuditRecord(record)) {
								<i class="pi pi-angle-down" aria-hidden="true"></i>
							} @else {
								<i class="pi pi-angle-right" aria-hidden="true"></i>
							}
						</span>
					</button>

					@if (isSelectedAuditRecord(record)) {
						<section class="rea-audit-inline-detail">
							@if (isAuditRecordLoading(record)) {
								<p class="rea-check-note">Cargando detalle histórico...</p>
							} @else {
								@if (selectedAuditDetail; as audit) {
									<div class="rea-section__header rea-section__header--compact">
										<div>
											<h5>Detalle de esta importación</h5>
											<p class="rea-section__hint">{{ audit.import.createdAt }}</p>
										</div>
										<p-button label="Cerrar detalle" severity="secondary" size="small" (onClick)="closeDetail.emit()"></p-button>
									</div>

									<p class="rea-check-note">{{ auditRecordDescription(audit.import) }}</p>
									@if (auditRecordNextStep(audit.import)) {
										<p class="rea-main-status__next-step">{{ auditRecordNextStep(audit.import) }}</p>
									}

									@if (auditRecordRecoveryAction(audit.import); as action) {
										<a
											pButton
											class="p-button-sm p-button-warning rea-action-link"
											icon="pi pi-external-link"
											[href]="action.url"
											[target]="action.target ?? '_blank'"
											rel="noopener noreferrer"
										>
											{{ action.label }}
										</a>
									}

									@if (isAuditError(audit.import)) {
										<a
											pButton
											class="p-button-sm p-button-help rea-action-link"
											icon="pi pi-envelope"
											[href]="supportEmailHrefForAuditRecord(audit.import)"
											target="_blank"
											rel="noopener noreferrer"
										>
											Enviar error a soporte
										</a>

										<app-rea-import-technical-details
											[details]="auditRecordTechnicalDetails(audit.import)"
										></app-rea-import-technical-details>
									}

									@if (selectedAuditChanges.length > 0) {
										<ul class="rea-list rea-list--changes rea-list--audit">
											@for (detail of selectedAuditChanges; track detail.code + detail.action) {
												<li>
													<i class="pi pi-history" aria-hidden="true"></i>
													<div>
														<b>{{ detail.label || detail.code }}</b>
														<small>{{ actionLabel(detail.action) }}</small>
														@for (message of detail.messages; track message) {
															<span>{{ message }}</span>
														}

														@if (isAuditError(audit.import)) {
															<app-rea-import-technical-details
																title="Antes/después para soporte"
																[details]="auditChangeTechnicalDetails(detail)"
															></app-rea-import-technical-details>
														}
													</div>
												</li>
											}
										</ul>
									}
								} @else {
									<p class="rea-check-note">{{ auditRecordDescription(record) }}</p>

									@if (isAuditError(record)) {
										<a
											pButton
											class="p-button-sm p-button-help rea-action-link"
											icon="pi pi-envelope"
											[href]="supportEmailHrefForAuditRecord(record)"
											target="_blank"
											rel="noopener noreferrer"
										>
											Enviar error a soporte
										</a>

										<app-rea-import-technical-details
											[details]="auditRecordTechnicalDetails(record)"
										></app-rea-import-technical-details>
									}
								}
							}
						</section>
					}
				</article>
			}
		</div>
	}
</section>
